<template>
<div class="chapter">
<div class="inner_page">
<p class="booktitle"><a id="page_xi"><strong><em>Scandal in Scotland</em></strong></a></p><a id="page_xi">
</a><p class="noindent"><a id="page_xi"></a><a id="page_xii"></a></p><a id="page_xii">
</a><div class="pagebreak"><a id="page_xii">
</a><p class="noindentb"><a id="page_xii"></a><a id="page_1"><em>A letter from Michael Hurst, explorer and Egyptologist, to his brother Captain William Hurst</em>.</a></p><a id="page_1">
<p class="noindent">William,</p>
<p class="indent">I doubt this will reach you before you set sail, but letter writing is one of my few diversions while locked in this godforsaken place. I shall endeavor to send this on the next English ship that arrives.</p>
<p class="indent">My captors are growing more impatient as the days pass. And while I’m perfectly capable of dealing with their rude treatment, being forced to remain in such close confines with my assistant, Miss Jane Smythe-Haughton, is making my captivity a living hell. She’s removed all of my precious brandy and has implemented an exercise regime. I feel as if I’ve returned to boarding school.</p>
<p class="indent">William, as soon as you can, pray release me.</p>
</a><p class="noindent"><a id="page_1"></a><a id="page_2"></a></p><a id="page_2">
</a></div><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// booktitle.vue?343b91e9